(() => {
  const root = document.querySelector("[data-storefront-homepage]");
  if (!root) return;

  const slides = Array.from(root.querySelectorAll("[data-hero-slide]"));
  const dots = Array.from(root.querySelectorAll("[data-hero-dot]"));
  const prev = root.querySelector("[data-hero-prev]");
  const next = root.querySelector("[data-hero-next]");
  if (slides.length === 0) return;

  const AUTO_PLAY_INTERVAL = 5000;
  let index = 0;
  let autoPlayTimer = null;

  const normalizeIndex = (targetIndex) => {
    return (targetIndex + slides.length) % slides.length;
  };

  const toggleActive = (elements, activeIndex) => {
    elements.forEach((element, elementIndex) => {
      element.classList.toggle("is-active", elementIndex === activeIndex);
    });
  };

  const render = () => {
    toggleActive(slides, index);
    toggleActive(dots, index);
  };

  const goTo = (targetIndex) => {
    index = normalizeIndex(targetIndex);
    render();
  };

  const move = (delta) => {
    goTo(index + delta);
  };

  const stopAutoPlay = () => {
    if (!autoPlayTimer) return;
    window.clearInterval(autoPlayTimer);
    autoPlayTimer = null;
  };

  const startAutoPlay = () => {
    if (slides.length <= 1) return;
    stopAutoPlay();
    autoPlayTimer = window.setInterval(() => {
      move(1);
    }, AUTO_PLAY_INTERVAL);
  };

  const moveByInteraction = (delta) => {
    move(delta);
    startAutoPlay();
  };

  const goToByInteraction = (targetIndex) => {
    goTo(targetIndex);
    startAutoPlay();
  };

  prev?.addEventListener("click", () => moveByInteraction(-1));
  next?.addEventListener("click", () => moveByInteraction(1));

  dots.forEach((dot, dotIndex) => {
    dot.addEventListener("click", () => {
      goToByInteraction(dotIndex);
    });
  });

  render();
  startAutoPlay();

  document.addEventListener("visibilitychange", () => {
    if (slides.length <= 1) return;
    if (document.hidden) {
      stopAutoPlay();
      return;
    }
    startAutoPlay();
  });

  const mobileMenuToggle = root.querySelector("[data-mobile-menu-toggle]");
  const mobileMenuPanel = root.querySelector("[data-mobile-menu-panel]");
  const mobileMenuBackdrop = root.querySelector("[data-mobile-menu-backdrop]");

  if (!mobileMenuToggle || !mobileMenuPanel || !mobileMenuBackdrop) return;

  const closeMobileMenu = () => {
    mobileMenuToggle.setAttribute("aria-expanded", "false");
    mobileMenuPanel.classList.remove("is-open");
    mobileMenuBackdrop.classList.remove("is-open");
    mobileMenuPanel.hidden = true;
    mobileMenuBackdrop.hidden = true;
  };

  const openMobileMenu = () => {
    mobileMenuToggle.setAttribute("aria-expanded", "true");
    mobileMenuPanel.hidden = false;
    mobileMenuBackdrop.hidden = false;
    mobileMenuPanel.classList.add("is-open");
    mobileMenuBackdrop.classList.add("is-open");
  };

  mobileMenuToggle.addEventListener("click", () => {
    const isExpanded = mobileMenuToggle.getAttribute("aria-expanded") === "true";
    if (isExpanded) {
      closeMobileMenu();
      return;
    }
    openMobileMenu();
  });

  mobileMenuBackdrop.addEventListener("click", closeMobileMenu);

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      closeMobileMenu();
    }
  });

})();
